import DeviceDetailsComponent from './DeviceDetailsComponent';

export default DeviceDetailsComponent;
